import { IConfigAPI_Auth, injectConfigAPI } from '../../interface/config';
import type { IContainer } from '../../interface/container';
import { injectFetch, injectLog } from '../../interface/util';
import type { IAuthAPI } from '../interface/auth';
import authImpl from './auth';

type AuthRequired = Required<IConfigAPI_Auth>;

function _isApiAuth(object: Partial<IConfigAPI_Auth> | undefined): object is AuthRequired {
    return object &&
        object?.clientId &&
        object?.clientSecret &&
        object?.grantType &&
        object?.password &&
        object?.username
        ? true
        : false;
}

function auth(container: IContainer): IAuthAPI {
    const fetcher = injectFetch(container);
    const logger = injectLog(container);
    const configAPI = injectConfigAPI(container);

    const authParams = configAPI
        .filter(config => _isApiAuth(config.auth) && config.url && config.extension?.auth)
        .map(config => ({
            ...(config.auth as Required<IConfigAPI_Auth>) /* type checked above */,
            apiUrl: config.url ?? '',
            apiExtension: config.extension?.auth ?? '',
        }));

    logger.assert(
        authParams.length > 0,
        `Failed to find authentication params for apiservice:auth`,
    );

    const auth: IAuthAPI = {
        authenticate: (apiURL: string, username: string, password: string, timeout?: number) =>
            authImpl(fetcher, logger, authParams, timeout),
    };

    return auth;
}

export default auth;
